<template>
    <div>
        <!-- Floating Button -->
        <v-btn fab
               dark
               color="primary"
               class="floating-btn"
               :style="language =='ar'?'left:20px;width:35px;height:35px':'right:20px;width:35px;height:35px' "
               @click="toggleChat">
            <v-icon small>mdi-headphones-settings</v-icon>
        </v-btn>

        <!-- Chat Widget -->
        <v-card v-if="chatVisible"
                class="chat-widget"
                :style="language=='ar'?'left:20px':'right:20px'"
                width="400"
                max-width="400">
            <v-toolbar dense dark color="primary" class="flex-grow-0">
                <v-toolbar-title class="ms-2">
                    {{$t('Chat')}}
                </v-toolbar-title>

            </v-toolbar>


            <!-- Chat messages -->
            <v-list dense>
                <v-list-item v-for="(message, index) in messages"
                             :key="index"
                             :class="{ 'from-bot-left': message.sender === 'bot' && language=='ar','from-bot-right': message.sender === 'bot' && language=='en', 'from-user-left': message.sender === 'user' && language=='ar', 'from-user-right': message.sender === 'user' && language=='en' }">
                    <v-list-item-content>
                        <v-list-item-title>
                            <div :class="message.sender" v-html="message.text"></div>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <!-- Message input -->
            <v-card-actions>
                <v-text-field v-model="newMessage"
                              :label="$t('TypeYourMessage')"
                              outlined
                              dense
                              hide-details
                              @keyup.enter="sendMessage" />
                <v-icon @click="sendMessage" color="primary" :class="['ms-2',{'rotate-180':language == 'ar'}]">mdi-send </v-icon>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>

    import BotService from '@/services/BotService'
    import { mapGetters } from 'vuex'
    export default {
        props: {
            value: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                chatVisible: this.value,  // Controls chat visibility
                newMessage: '',
                messages: [
                    { sender: 'bot', text: this.$t('HowCanIAssistYouToday') }
                ],
                apitoken: ''
            }
        },
        computed: {
            ...mapGetters('user', ['language']),

            getLanguage() {
                return this.language == null ? 'ar' : this.language

            },
        },
        watch: {
            value(newValue) {
                this.chatVisible = newValue // Sync when prop changes
            }
        },
        methods: {
            toggleChat() {
                this.chatVisible = !this.chatVisible  // Toggle chat visibility
                this.$emit('openchat', this.chatVisible)
            },
            sendMessage() {
                if (this.newMessage.trim()) {
                    // Add user message
                    this.messages.push({
                        sender: 'user',
                        text: this.newMessage
                    })

                    const userMessage = this.newMessage  // Capture user input
                    this.newMessage = ''  // Clear input field

                    // Simulate bot response
                    this.$nextTick(() => {
                        setTimeout(async () => {
                            var resp = await this.generateBotResponse(userMessage)
                            this.messages.push({
                                sender: 'bot',
                                text: resp.response// Simple response function
                            })
                            //add suggestions too using resp.suggestions
                            // Scroll to bottom after bot response
                            this.scrollToBottom()
                        }, 1000)
                    })
                }
            },
            async generateBotResponse(userMessage) {
                var message = await BotService.generateBotResponse(userMessage)
                return message.data
                /*if (this.apitoken == '') {
                    const params = {
                        client_id: '71fa3f6a-8267-4bfc-80b1-816a86acd860',
                        client_secret: 'f8654b16-aa51-4e85-88e6-0e2b710a4bc0',
                        grant_type: 'password',
                        scope: 'IdentityServerApi',
                        username: 'admin',
                        password: 'P@$$w0rd'
                    }
                    const options = {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        },
                        body: new URLSearchParams(params)
                    }
                    let url = 'https://cm-iam.momah.gov.sa:8443/connect/token'
                    const response = await fetch(url, options)

                    const json = await response.json()
                    this.apitoken = JSON.stringify(json)
                    const jsonObj = JSON.parse(JSON.stringify(json))

                    for (var key in jsonObj) {
                        this.apitoken = jsonObj['access_token']
                    }
                }
                let r = 'default-1-momah_survey-1733152312'
                const API_URL_MASSAGE = 'https://cm-services.momah.gov.sa:8445/chatbot/api/bot/momah_survey/context/' + r + '/message'
                const responseffmssage = await fetch(API_URL_MASSAGE, {
                    method: 'POST',
                    headers: {
                        'accept': 'application/json',
                        'Authorization': 'Bearer ' + this.apitoken,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        'clear_context': false,
                        'extra_http_headers': {
                        },
                        'extra_body_params': {},
                        'extra_http_headers': {},
                        'extra_url_params': {
                        },
                        'message': userMessage
                    })
                })
                const jsonmessage = await responseffmssage.json()
                const inputInitHeight = chatInput.scrollHeight
                const jsomessagechat = JSON.stringify(jsonmessage)
                return JSON.parse(jsomessagechat)
                // Basic bot response logic
                /*if (userMessage.toLowerCase().includes('hello')) {
                    return 'Hi there! How can I help you?'
                } else {
                    return 'لست متأكدًا من أنني أفهم ذلك. هل يمكنك التوضيح؟'
                }*/
            },

            scrollToBottom() {
                const chatList = this.$el.querySelector('.v-list')
                chatList.scrollTop = chatList.scrollHeight
            }
        }
    }
</script>

<style scoped>
    .rotate-180 {
        transform: rotate(180deg);
    }
    /* Floating Button */
    .floating-btn {
        position: fixed;
        bottom: 50px;
    }

    /* Chat Widget */
    .chat-widget {
        position: fixed;
        bottom: 80px;
        height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        z-index:1000000
    }

    .v-list {
        flex: 1;
        overflow-y: auto;
    }

    .message {
        margin-bottom: 10px;
    }


    .bot {
        color: #413d13;
        font-size: 15px;
        background: #fbfbfb;
        display: block;
        border-radius: 7px;
        padding: 7px;
        white-space: normal !important
    }

    .from-user-right {
        text-align: right;
    }

    .from-user-left {
        text-align: left;
    }

    .user {
        color: green;
        background: #f1f1f1;
        display: block;
        padding: 7px;
        border-radius: 7px;
        white-space:normal !important
    }
</style>
